import { useQuery, useQueryClient } from 'react-query'
import { AxiosError } from 'axios'
import { McdApiErrorInfo, McdApiErrorStateKeys } from './useMcdApi'
import { useCallback } from 'react'

/** 汎用MCD APIエラーデータ */
export const useMcdApiErrorData = () => {
  const {data: mcdApiErrorData} = useQuery<McdApiErrorInfo | null>([McdApiErrorStateKeys.McdApiError], {enabled:false, initialData:undefined})
  const {data: apiCommunicationErrorData} = useQuery<AxiosError | null>([McdApiErrorStateKeys.ApiCommunicationError], {enabled:false, initialData:undefined})
  const queryClient = useQueryClient()

  // ユーザー向けエラーメッセージ
  let friendlyErrorMessage = ''
  if (mcdApiErrorData?.message) {
    let message = ''
    if (mcdApiErrorData.errorCode.startsWith('E-CGTC')) {
      message = mcdApiErrorData.message
    } else {
      message = mcdApiErrorData.errorCode
    }
    friendlyErrorMessage = `システムエラーが発生しました。(${message})`
  }
  if (apiCommunicationErrorData?.message) {
    friendlyErrorMessage = `通信エラーが発生しました。(${apiCommunicationErrorData.response?.status})`
  }

  // エラーデータのクリア
  const clear = useCallback(() => {
    queryClient.setQueryData([McdApiErrorStateKeys.McdApiError], null)
    queryClient.setQueryData([McdApiErrorStateKeys.ApiCommunicationError], null)
  }, [queryClient])

  return {mcdApiErrorData, apiCommunicationErrorData, friendlyErrorMessage, clear}
}

export default useMcdApiErrorData
